module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n          Pályázat választás\n        ")]), _vm._v(" "), _c('comboboxV2', {
    attrs: {
      "label": "Pályázott ösztöndíj",
      "name": "osztondij_id",
      "errors": _vm.errors,
      "id": "osztondij_id",
      "options": _vm.palyazhato_osztondijak
    },
    on: {
      "onChange": _vm.osztondijValtoztat
    },
    model: {
      value: (_vm.form.values.osztondij_id),
      callback: function($$v) {
        _vm.form.values.osztondij_id = $$v
      },
      expression: "form.values.osztondij_id"
    }
  })], 1), _vm._v(" "), (_vm.form.values.osztondij_id != '') ? [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Név",
      "errors": _vm.errors,
      "id": "nev",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.nev),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.nev = $$v
      },
      expression: "form.hallgato_alapadatok.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Születési hely, idő",
      "errors": _vm.errors,
      "id": "szulhelyido",
      "name": "szulhelyido"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.szulhelyido),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.szulhelyido = $$v
      },
      expression: "form.hallgato_alapadatok.szulhelyido"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Neptunkód",
      "errors": _vm.errors,
      "regexp_filter": "[a-zA-Z0-9]+",
      "id": "neptunkod",
      "name": "neptunkod"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.neptunkod),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.neptunkod = $$v
      },
      expression: "form.hallgato_alapadatok.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Email cím",
      "errors": _vm.errors,
      "id": "email",
      "name": "email",
      "regexp_filter": "[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.email),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.email = $$v
      },
      expression: "form.hallgato_alapadatok.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Mobilszám",
      "errors": _vm.errors,
      "id": "mobilszam",
      "name": "mobilszam",
      "regexp_filter": "[+0-9 /-]+"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.mobilszam),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.mobilszam = $$v
      },
      expression: "form.hallgato_alapadatok.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.karLatszik()),
      expression: "karLatszik()"
    }],
    attrs: {
      "errors": _vm.errors,
      "label": "Kar",
      "id": "kar",
      "name": "kar",
      "options": _vm.karok
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.kar),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.kar = $$v
      },
      expression: "form.hallgato_alapadatok.kar"
    }
  }), _vm._v(" "), _c('comboboxV2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doktoriIskolaLatszik()),
      expression: "doktoriIskolaLatszik()"
    }],
    attrs: {
      "errors": _vm.errors,
      "label": "Doktori Iskola",
      "id": "doktori_iskola",
      "name": "doktori_iskola",
      "options": _vm.doktori_iskolak
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.doktori_iskola),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.doktori_iskola = $$v
      },
      expression: "form.hallgato_alapadatok.doktori_iskola"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.szakLatszik()),
      expression: "szakLatszik()"
    }],
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\\-\\,]+",
      "label": "Szak",
      "errors": _vm.errors,
      "id": "szak",
      "name": "szak"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.szak),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.szak = $$v
      },
      expression: "form.hallgato_alapadatok.szak"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tanszekLatszik()),
      expression: "tanszekLatszik()"
    }],
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\\-\\,]+",
      "label": "Tanszék",
      "errors": _vm.errors,
      "id": "tanszek",
      "name": "tanszek"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.tanszek),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.tanszek = $$v
      },
      expression: "form.hallgato_alapadatok.tanszek"
    }
  })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Pályázott ösztöndíjas jogviszony időtartama",
      "name": "jogviszony_idotartam",
      "id": "jogviszony_idotartam",
      "options": _vm.jogviszonyidotartamok
    },
    model: {
      value: (_vm.form.values.jogviszony_idotartam),
      callback: function($$v) {
        _vm.form.values.jogviszony_idotartam = $$v
      },
      expression: "form.values.jogviszony_idotartam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "ÚNKP Ösztöndíjban részesültem",
      "name": "unkp_reszesult_e",
      "id": "unkp_reszesult_e",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.unkp_reszesult_e),
      callback: function($$v) {
        _vm.form.values.unkp_reszesult_e = $$v
      },
      expression: "form.values.unkp_reszesult_e"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Kutatási/művészeti téma címe",
      "errors": _vm.errors,
      "id": "tema_cim",
      "name": "tema_cim"
    },
    model: {
      value: (_vm.form.values.tema_cim),
      callback: function($$v) {
        _vm.form.values.tema_cim = $$v
      },
      expression: "form.values.tema_cim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Kutatási/művészeti téma tudományterületi besorolása",
      "id": "tudomanyterulet",
      "name": "tudomanyterulet",
      "options": _vm.tudomanyteruletek
    },
    on: {
      "onChange": function($event) {
        _vm.tudomanyAgak(true)
      }
    },
    model: {
      value: (_vm.form.values.tudomanyterulet),
      callback: function($$v) {
        _vm.form.values.tudomanyterulet = $$v
      },
      expression: "form.values.tudomanyterulet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Kutatási/művészeti téma tudományági besorolása",
      "id": "tudomanyag",
      "name": "tudomanyag",
      "options": _vm.tudomanyagak
    },
    model: {
      value: (_vm.form.values.tudomanyag),
      callback: function($$v) {
        _vm.form.values.tudomanyag = $$v
      },
      expression: "form.values.tudomanyag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Témavezető neve",
      "errors": _vm.errors,
      "id": "temavezeto_neve",
      "name": "temavezeto_neve",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_neve),
      callback: function($$v) {
        _vm.form.values.temavezeto_neve = $$v
      },
      expression: "form.values.temavezeto_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Témavezető e-mail címe",
      "errors": _vm.errors,
      "id": "temavezeto_email",
      "name": "temavezeto_email",
      "regexp_filter": "[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}"
    },
    model: {
      value: (_vm.form.values.temavezeto_email),
      callback: function($$v) {
        _vm.form.values.temavezeto_email = $$v
      },
      expression: "form.values.temavezeto_email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Témavezető mobilszáma",
      "errors": _vm.errors,
      "id": "temavezeto_mobil",
      "name": "temavezeto_mobil",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_mobil),
      callback: function($$v) {
        _vm.form.values.temavezeto_mobil = $$v
      },
      expression: "form.values.temavezeto_mobil"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ABTudomanyosPublikacioSzerzojeLatszik()),
      expression: "ABTudomanyosPublikacioSzerzojeLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "tooltipDescription": "’Igen’ válasz esetén kérjük a publikáció(ka)t feltölteni a „A pályázó teljesítményét alátámasztó dokumentumok” pontban.",
      "label": "Scimago Journal Ranking szerinti Q1/Q2 és/vagy a Magyar Tudományos Akadémia tudományos osztályai által “A” vagy “B” kategóriába sorolt folyóiratokban megjelent tudományos publikáció szerzője",
      "name": "a_b_tudomanyos_publikacio_szerzoje",
      "id": "a_b_tudomanyos_publikacio_szerzoje",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.a_b_tudomanyos_publikacio_szerzoje),
      callback: function($$v) {
        _vm.form.values.a_b_tudomanyos_publikacio_szerzoje = $$v
      },
      expression: "form.values.a_b_tudomanyos_publikacio_szerzoje"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.proScientiaLatszik()),
      expression: "proScientiaLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Az Országos Tudományos Diákköri Tanács által adományozott Pro Scientia/Arte Aranyérem kitüntetésben részesült VAGY az Országos Tudományos Diákköri Konferencián (OTDK) elért I. II. vagy III. helyezéssel rendelkezik.",
      "name": "pro_scientia_arte_reszvetel",
      "id": "pro_scientia_arte_reszvetel",
      "options": _vm.igen_nem
    },
    on: {
      "onChange": function () {
        _vm.$refs.pro_scientia_arte_igazolas.deleteFiles();
      }
    },
    model: {
      value: (_vm.form.values.pro_scientia_arte_reszvetel),
      callback: function($$v) {
        _vm.form.values.pro_scientia_arte_reszvetel = $$v
      },
      expression: "form.values.pro_scientia_arte_reszvetel"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmdkLatszik()),
      expression: "tmdkLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Pályázó az elmúlt 5 évben rendelkezik TMDK/szakdolgozat/diplomamunka témavezetéssel",
      "id": "tmdk_reszvetel",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.tmdk_reszvetel),
      callback: function($$v) {
        _vm.form.values.tmdk_reszvetel = $$v
      },
      expression: "form.values.tmdk_reszvetel"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kutatocsoportEgyuttmukodesLatszik()),
      expression: "kutatocsoportEgyuttmukodesLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Kutatócsoporttal együttműködés",
      "name": "kutatocsoport_egyuttmukodes",
      "id": "kutatocsoport_egyuttmukodes",
      "options": _vm.igen_nem
    },
    on: {
      "onChange": function () {
        _vm.$refs.kutatocsoport_egyuttmukodes_igazolas.deleteFiles();
      }
    },
    model: {
      value: (_vm.form.values.kutatocsoport_egyuttmukodes),
      callback: function($$v) {
        _vm.form.values.kutatocsoport_egyuttmukodes = $$v
      },
      expression: "form.values.kutatocsoport_egyuttmukodes"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.pro_scientia_arte_reszvetel == 'igen'),
      expression: "form.values.pro_scientia_arte_reszvetel == 'igen'"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "pro_scientia_arte_igazolas",
    attrs: {
      "max_uploaded_files": "10",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "pro_scientia_arte_igazolas",
      "label": "Pro Scientia/Arte Aranyérem vagy OTDK I., II., III. helyezés igazolása",
      "name": "pro_scientia_arte_igazolas",
      "loaded_files": _vm.form.values.pro_scientia_arte_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'pro_scientia_arte_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.kutatocsoport_egyuttmukodes == 'igen'),
      expression: "form.values.kutatocsoport_egyuttmukodes == 'igen'"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "kutatocsoport_egyuttmukodes_igazolas",
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "kutatocsoport_egyuttmukodes_igazolas",
      "label": "Kutatócsoporttal együttműködés igazolás",
      "name": "kutatocsoport_egyuttmukodes_igazolas",
      "loaded_files": _vm.form.values.kutatocsoport_egyuttmukodes_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'kutatocsoport_egyuttmukodes_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "palyazati_adatlap",
      "label": "Kitöltött, aláírt pályázati adatlap",
      "name": "palyazati_adatlap",
      "loaded_files": _vm.form.values.palyazati_adatlap
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazati_adatlap');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "errors": _vm.errors,
      "id": "palyazati_adatlap_szerkesztheto",
      "label": "Kitöltött pályázati adatlap szerkeszthető (Excel fájl)",
      "name": "palyazati_adatlap_szerkesztheto",
      "loaded_files": _vm.form.values.palyazati_adatlap_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazati_adatlap_szerkesztheto');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "alairt_kutatasi_terv",
      "label": "Aláírt kutatási terv (témavezető és pályázó által aláírva)",
      "name": "alairt_kutatasi_terv",
      "loaded_files": _vm.form.values.alairt_kutatasi_terv
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'alairt_kutatasi_terv');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "alairt_palyazoi_nyilatkozat",
      "label": "Aláírt pályázói nyilatkozat",
      "name": "alairt_palyazoi_nyilatkozat",
      "loaded_files": _vm.form.values.alairt_palyazoi_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'alairt_palyazoi_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "alairt_intezmenyi_fogado_nyilatkozat",
      "label": "Aláírt intézményi fogadó nyilatkozat",
      "name": "alairt_intezmenyi_fogado_nyilatkozat",
      "loaded_files": _vm.form.values.alairt_intezmenyi_fogado_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'alairt_intezmenyi_fogado_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kitoltottAlairtTemavezetoiNyilatkozatLatszik()),
      expression: "kitoltottAlairtTemavezetoiNyilatkozatLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf",
      "errors": _vm.errors,
      "id": "kitoltott_alairt_temavezetoi_nyilatkozat",
      "label": "Kitöltött, aláírt témavezetői nyilatkozat",
      "name": "kitoltott_alairt_temavezetoi_nyilatkozat",
      "loaded_files": _vm.form.values.kitoltott_alairt_temavezetoi_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'kitoltott_alairt_temavezetoi_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tanulmanyiEredmenyIgazolasLatszik()),
      expression: "tanulmanyiEredmenyIgazolasLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "tanulmanyi_eredmeny_igazolas",
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "tanulmanyi_eredmeny_igazolas",
      "label": _vm.tanulmanyiEredmenyIgazolasLabel(),
      "name": "tanulmanyi_eredmeny_igazolas",
      "loaded_files": _vm.form.values.tanulmanyi_eredmeny_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tanulmanyi_eredmeny_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "100",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "palyazo_teljesitmeny_igazolas",
      "label": "A pályázó teljesítményét alátámasztó dokumentumok (amennyiben a pályázó rendelkezésére áll, pl. publikációs lista, konferencia részvételt, kiállítást igazoló dokumentumok, további tudományos teljesítmény dokumentációja, szakmai-közösségi tevékenység, kutatásokban, kutatási terepmunkában való részvétének igazolása, tudományos ismeretterjesztő/tudomány népszerűsítő tevékenység dokumentációja, egyéb szakmai (tudományos és oktatási) tevékenységet bemutató dokumentáció, versenyeredmények.",
      "name": "palyazo_teljesitmeny_igazolas",
      "loaded_files": _vm.form.values.palyazo_teljesitmeny_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazo_teljesitmeny_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nyelvtudastIgazoloDokumentumLatszik()),
      expression: "nyelvtudastIgazoloDokumentumLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "nyelvtudast_igazolo_dokumentum",
    attrs: {
      "max_uploaded_files": "20",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "nyelvtudast_igazolo_dokumentum",
      "label": "Nyelvtudást igazoló dokumentum",
      "name": "nyelvtudast_igazolo_dokumentum",
      "loaded_files": _vm.form.values.nyelvtudast_igazolo_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'nyelvtudast_igazolo_dokumentum');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "hallgatoi_munkaltatoi_jogviszonyigazolas",
      "label": "Hallgatói/munkáltatói jogviszonyigazolás Tanulmányi Osztály / Doktori Iskola / Humánerőforrás Osztály által hitelesítve. Ennek hiányában a pályázó által írt és aláírt nyilatkozat, hogy 2024. szeptember 1-ig AKTÍV hallgatói jogviszonya keletkezik VAGY fiatal oktató, kutató kategóriákban a 2024. szeptember 1. - 2025. augusztus 31. közötti oktatói, kutatói munkavégzésre irányuló jogviszonya, vagy munkavégzésre irányuló egyéb jogviszonya legkésőbb 2024. szeptember 1. napjáig várhatóan létrejön.",
      "name": "hallgatoi_munkaltatoi_jogviszonyigazolas",
      "loaded_files": _vm.form.values.hallgatoi_munkaltatoi_jogviszonyigazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'hallgatoi_munkaltatoi_jogviszonyigazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abszolutoriumMegszerzesetIgazoloDokumentum()),
      expression: "abszolutoriumMegszerzesetIgazoloDokumentum()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "abszolutorium_megszerzeset_igazolo_dokumentum",
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "abszolutorium_megszerzeset_igazolo_dokumentum",
      "label": "Az abszolutórium megszerzését igazoló dokumentum elektronikusan VAGY PhD/DLA fokozat megszerzését igazoló dokumentum (amennyiben a pályázat benyújtásakor a fokozatot megszerezte)",
      "name": "abszolutorium_megszerzeset_igazolo_dokumentum",
      "loaded_files": _vm.form.values.abszolutorium_megszerzeset_igazolo_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'abszolutorium_megszerzeset_igazolo_dokumentum');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doktoriKepzesReszetKepezoFelkeszulesbenValoReszveteltIgazoloDokumentumLatszik()),
      expression: "doktoriKepzesReszetKepezoFelkeszulesbenValoReszveteltIgazoloDokumentumLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum",
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum",
      "label": "Doktori képzés részét képező felkészülésben való részvételt igazoló dokumentum",
      "name": "doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum",
      "loaded_files": _vm.form.values.doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.felviHuJelentkezesiAdatlapLatszik()),
      expression: "felviHuJelentkezesiAdatlapLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "felvi_hu_jelentkezesi_adatlap",
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "felvi_hu_jelentkezesi_adatlap",
      "label": "Felvi.hu felületéről generálható felvételi jelentkezési adatlap",
      "name": "felvi_hu_jelentkezesi_adatlap",
      "loaded_files": _vm.form.values.felvi_hu_jelentkezesi_adatlap
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'felvi_hu_jelentkezesi_adatlap');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik()),
      expression: "nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve",
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve",
      "label": "Nyilatkozat felvételi jelentkezésről illetékes Doktori Iskola ügyintézője által hitelesítve. (A nyilatkozatot a pályázó készíti el, arra vonatkozóan, hogy melyik doktori iskolába adta be felvételi jelentkezését.)",
      "name": "nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve",
      "loaded_files": _vm.form.values.nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.tmdk_reszvetel == 'igen'),
      expression: "form.values.tmdk_reszvetel == 'igen'"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    ref: "tmdk_temavezetes_igazolas",
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "tmdk_temavezetes_igazolas",
      "label": "TMDK témavezetés igazolása (Egyetemi Tudományos és Művészeti Diákköri Tanács által) ÉS/VAGY szakdolgozat/diplomamunka témavezetés igazolása felettes vezető által",
      "name": "tmdk_temavezetes_igazolas",
      "loaded_files": _vm.form.values.tmdk_temavezetes_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tmdk_temavezetes_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nyilatkozat_elfogadasa),
      expression: "nyilatkozat_elfogadasa"
    }],
    attrs: {
      "id": "nyilatkozat_elfogadasa",
      "name": "nyilatkozat_elfogadasa",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.nyilatkozat_elfogadasa) ? _vm._i(_vm.nyilatkozat_elfogadasa, "1") > -1 : (_vm.nyilatkozat_elfogadasa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.nyilatkozat_elfogadasa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.nyilatkozat_elfogadasa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.nyilatkozat_elfogadasa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.nyilatkozat_elfogadasa = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozat_elfogadasa') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }), _vm._v(" "), (_vm.remedy) ? _c('div', [_c('div', {
    staticClass: "info-box warning",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n            Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "javascript:void(0)",
      "title": ""
    },
    on: {
      "click": function($event) {
        _vm.remedy_popup = true;
      }
    }
  }, [_vm._v("Fellebezés")])]) : _vm._e(), _vm._v(" "), (_vm.remedy_user != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_user.name))]), _vm._v(" (" + _vm._s(_vm.remedy_user.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_user.msg))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.remedy_admin != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés válasz")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_admin.name))]), _vm._v(" (" + _vm._s(_vm.remedy_admin.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_admin.msg))
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.remedy && _vm.$route.query.id != undefined && _vm.remedy_popup) ? _c('Fellebezes', {
    attrs: {
      "form_id": _vm.$route.query.id
    },
    on: {
      "close": function (final) {
        _vm.remedy_popup = false;
        if (final) { _vm.remedy = false; }
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/ekop_2024_palyazati_felhivas.pdf",
      "title": "Pályázati felhívás letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Pályázati felhívás")]), _vm._v(" letöltés\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Hallgató alapadatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Pályázat alapadatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Dokumentumok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/kutatasi_terv_ekop_2024.docx",
      "title": "Kutatási terv letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Kutatási terv")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/palyazati_adatlap_ekop_2024.xlsx",
      "title": "Pályázati adatlap letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Pályázati adatlap")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/palyazoi_nyilatkozat_ekop_2024.docx",
      "title": "Pályázói nyilatkozat letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Pályázói nyilatkozat")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/temavezetoi_nyilatkozat_ekop_2024.docx",
      "title": "Témavezetői nyilatkozat letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Témavezetői nyilatkozat")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/tudomanyagi_kepzesi_besorolas_ekop_2024.docx",
      "title": "Tudományági besorolás letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Tudományági besorolás")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/felsooktatasi_intezmeny_szandeknyilatkozata_ekop_2024.docx",
      "title": "Széchenyi István Egyetem szándéknyilatkozata a kutatás befogadásáról letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Széchenyi István Egyetem szándéknyilatkozata a kutatás befogadásáról")]), _vm._v(" letöltés\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozat_elfogadasa"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', [_vm._v("\n                  Jelen pályázati anyagom benyújtásával egyidejűleg kijelentem, hogy nyertes pályázatom esetén az Egyetemi Kutató Ösztöndíj Program ösztöndíjas jogviszony létesítésekor igazolom az ösztöndíjszerződés létesítéséhez, valamint az ösztöndíjas jogviszony fenntartásához szükséges "), _c('strong', [_c('u', [_vm._v("AKTÍV")]), _vm._v(" hallgatói jogviszonyomat/ munkaviszonyomat vagy munkavégzésre irányuló egyéb jogviszonyomat")]), _vm._v(", és vállalom, hogy ezt az ösztöndíjas jogviszony teljes időtartama alatt mindvégig fenntartom.\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbda939e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/ekop2024.vue
// module id = 408
// module chunks = 0